export const BillingCycles = [
  {
    "period": "Monthly"
  },
  {
    "period": "Yearly"
  }
]